/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

const baseStyles = () => css`
    position: relative;
    margin: var(--layout-spacing-12) 0 0;

    .controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: var(--layout-spacing-24);

        .sorting {
            display: flex;
            align-items: center;

            .display-mode {
                margin-right: var(--layout-spacing-24);
                min-width: 7.2rem;
            }

            .sort-by {
                margin-bottom: 0;
            }
        }
    }

    .pagination-bottom {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: var(--layout-spacing-24) auto;
    }

    .back-to-in-stock-models {
        text-align: center;
        margin-bottom: var(--layout-spacing-24);
    }

    .back-to-in-stock-models,
    .back-to-in-stock-models-button,
    .find-out-of-stock-models-button,
    .show-all-models-link,
    .no-results-message {
        font-size: 1.2rem;
    }

    .pagination {
        display: flex;
        justify-content: center;
        font-size: 1.2rem;

        .results-meta {
            display: flex;
            align-items: center;

            > span {
                margin-right: var(--layout-spacing-12);
            }

            > button {
                margin-right: var(--layout-spacing-24);
            }
        }
    }

    .show-more {
        padding: var(--layout-spacing-72);
    }

    .results-message {
        text-align: center;

        .title {
            margin-bottom: 0;
        }

        .subtitle {
            font-size: 1.2rem;
            color: var(--colors-text-primary);
            margin: 0.3rem 0;
        }

        & + .pagination {
            margin-top: var(--layout-spacing-24);
        }
    }

    .total-results-skeleton {
        width: 13rem;
    }

    .see-less {
        padding: 2rem 0;
        margin-top: var(--layout-spacing-48);
    }

    .content-line {
        margin-top: var(--layout-spacing-48);
    }

    ${smallTablet(css`
        margin-bottom: 0;

        .controls {
            display: none;

            .sorting {
                display: none;
            }
        }

        .pagination {
            flex-grow: 1;
            justify-content: space-between;

            .results-meta {
                > span {
                    color: var(--colors-text-primary);
                }
            }
            nav {
            }
        }

        .total-results-skeleton {
            width: 5.3rem;
        }

        .pagination-bottom .pagination {
            justify-content: center;
        }

        .see-less,
        .content-line {
            margin-top: var(--layout-spacing-24);
        }
    `)}
`;

export const styles = () => css`
    ${baseStyles()}
`;
